import Dexie, { Table } from 'dexie';

export interface LocalRepairQueue {
  id?: number;
  itemId: string;
  technicianId: string;
  technicianName: string;
  date: any;
  report: string;
  partsChanged: string;
  faultyPartPhotos: string[];
  replacementPartPhotos: string[];
  cost?: number;
  costCurrency: string;
  gpsLat?: number;
  gpsLng?: number;
  conditionScore: number;
}

export class VerisureLocalDatabase extends Dexie {
  queuedRepairs!: Table<LocalRepairQueue, number>;

  constructor() {
    super('VerisureLocalDB');
    this.version(1).stores({
      queuedRepairs: '++id, itemId, technicianId, date'
    });
  }
}

export const localDb = new VerisureLocalDatabase();

// Sync function to upload queued repairs when online
export const syncQueuedRepairs = async (uploadFunction: (data: any) => Promise<any>) => {
  if (!navigator.onLine) return;
  
  const repairs = await localDb.queuedRepairs.toArray();
  for (const repair of repairs) {
    try {
      // Omit the local 'id'
      const { id, ...repairData } = repair;
      await uploadFunction(repairData);
      
      // Delete from local queue after successful upload
      if (id !== undefined) {
        await localDb.queuedRepairs.delete(id);
      }
    } catch (error) {
      console.error("Failed to sync repair:", repair, error);
    }
  }
};
